import React from 'react';
import { AlertTriangle, TrendingDown } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { painPaths } from '../data/painPaths';
const toneStyles = {
  warning: {
    card: 'border-amber-500/25 hover:border-amber-500/45',
    glow: 'bg-amber-500/[0.07]',
    icon: 'text-amber-400/90',
    metric: 'text-amber-300'
  },
  danger: {
    card: 'border-crimson/35 hover:border-crimson/60',
    glow: 'bg-crimson/[0.09]',
    icon: 'text-[#e08a91]',
    metric: 'text-[#e08a91]'
  },
  gold: {
    card: 'border-gold-400/45 hover:border-gold-400/70',
    glow: 'bg-gold-400/[0.09]',
    icon: 'text-gold-300',
    metric: 'text-gold-300'
  }
} as const;
export function PainSection() {
  return <section className="cv-section relative w-full overflow-hidden border-y border-white/[0.06] bg-ink-950 py-14 sm:py-20 md:py-28" data-id="element-180" data-mp="2g76js5iux3mv">
      <div className="relative mx-auto max-w-6xl px-5 sm:px-6" data-id="element-181" data-mp="278b9ah8s57dr">
        <SectionHeading label="El Costo de la Ceguera" icon={TrendingDown} title={<>
              La vejez no es negociable.{' '}
              <span className="gold-text" data-id="element-183" data-mp="3nkw16odfi1ll">Su estupidez financiera sí.</span>
            </>} data-id="element-182" data-mp="27anpaouz97o6" />

        <Reveal delay={0.05} className="mx-auto mt-6 max-w-2xl text-center sm:mt-8" data-id="element-184" data-mp="5f16qakgko3c">
          <p className="text-[14.5px] leading-relaxed text-[#a7adb8] sm:text-[15px]" data-id="element-185" data-mp="h970udknxol">
            Cada día que pasa sin la señalización celular correcta, su cuerpo se degrada. Sus
            articulaciones crujen, su metabolismo se estanca y su vitalidad se apaga. Usted sabe que
            necesita los péptidos, pero se enfrenta a dos caminos mediocres.
          </p>
        </Reveal>

        <div className="mt-9 grid gap-4 sm:mt-14 sm:gap-5 md:grid-cols-3" data-id="element-186" data-mp="3duudvyswgn7q">
          {painPaths.map((path, index) => {
          const tone = toneStyles[path.tone];
          const Icon = path.icon;
          return <Reveal key={path.id} delay={index * 0.08} data-id="element-187" data-mp="2l4uiqro7aoi2" data-mpi={index}>
                <article className={`ease-luxe group relative h-full overflow-hidden rounded-2xl border bg-gradient-to-b from-ink-800 to-ink-950 p-5 transition-[transform,border-color] duration-300 hover:-translate-y-1.5 sm:p-7 ${tone.card}`} data-id="element-188" data-mp="p2r4bm1o34se">
                  <span className={`pointer-events-none absolute -right-16 -top-16 hidden h-40 w-40 rounded-full blur-2xl sm:block ${tone.glow}`} aria-hidden="true" data-id="element-189" data-mp="12vqi9jlswqxu" />
                  <Icon className={`h-6 w-6 ${tone.icon}`} strokeWidth={1.6} aria-hidden="true" data-id="element-190" data-mp="b52l0in905pg" />
                  <h3 className="mt-4 text-[17px] font-bold tracking-tight text-[#f0ede7] sm:mt-5 sm:text-lg" data-id="element-191" data-mp="f4l5xef2kgsa">
                    {path.label}
                  </h3>
                  <div className="mt-2.5 flex items-baseline gap-2 font-mono sm:mt-3" data-id="element-192" data-mp="1ql1kl5isute3">
                    <span className={`text-xl font-bold ${tone.metric}`} data-id="element-193" data-mp="1vjw1g1x7i7vk">{path.metric}</span>
                    <span className="text-[10px] uppercase tracking-[0.1em] text-ash" data-id="element-194" data-mp="1vlp99kjk2y55">
                      {path.metricLabel}
                    </span>
                  </div>
                  <p className="mt-3.5 text-[13.5px] leading-relaxed text-[#9ba1ac]" data-id="element-195" data-mp="20phyhtcpy0f9">
                    {path.description}
                  </p>
                </article>
              </Reveal>;
        })}
        </div>

        <Reveal delay={0.1} className="mx-auto mt-9 max-w-3xl sm:mt-14" data-id="element-196" data-mp="1mx1uap82zwcr">
          <div className="flex flex-col items-start gap-3.5 rounded-xl border border-crimson/30 bg-crimson/[0.06] p-5 sm:flex-row sm:items-center sm:gap-6 sm:p-7" data-id="element-197" data-mp="1mv8m35htl42n">
            <AlertTriangle className="h-6 w-6 shrink-0 text-[#e08a91] sm:h-7 sm:w-7" strokeWidth={1.6} aria-hidden="true" data-id="element-198" data-mp="1czx48eb47gqo" />
            <p className="text-[14.5px] leading-relaxed text-[#d3cfc7]" data-id="element-199" data-mp="37dgaccj7o7nl">
              Seguir ignorando el acceso al "Lujo de Farmacia" es, esencialmente, aceptar una{' '}
              <span className="font-semibold text-[#f0b4b9]" data-id="element-200" data-mp="3aerrtxwcqcip">multa de $5,000 USD al año</span> por el
              simple hecho de no saber navegar el sistema.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}